import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import * as Icon from 'react-feather'

const Error = ({ error, link, classes }) => {
  let alertColor = 'c-alert--danger'
  let btnColor = 'c-btn--primary'

  if (classes !== null && classes !== undefined) {
    alertColor = classes.alertDanger
    btnColor = classes.buttonDanger
  }
  return (
    <div className={`c-alert ${alertColor} alert`}>
      <span className="c-alert__icon">
        <Icon.Slash />
      </span>
      <div className="c-alert__content">
        <h4 className="c-alert__title">Nothing to show</h4>
        <p>{error}</p>
        {link ? (
          <div className="u-pt-medium">
            {/*TODO : CHANGE LINK BELOW TO BACK BUTTON*/}
            <Link to={link.url} className={`c-btn ${btnColor} has-arrow u-text-center`}>
              {' '}
              {link.title}{' '}
            </Link>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

Error.propTypes = {
  error: PropTypes.string.isRequired,
  link: PropTypes.object,
  classes: PropTypes.object,
}

export default Error
